function createAccordion(accordionSelector, options = {}) {
    const defaultOptions = {
        triggerClass: 'accordion-trigger',
        contentClass: 'accordion-content',
        openClass: 'open',
        transitionDuration: 300, // Default animation duration in ms
    };

    const settings = { ...defaultOptions, ...options };

    document.querySelectorAll(`${accordionSelector} .${settings.triggerClass}`).forEach(trigger => {
        trigger.addEventListener('click', function() {
            const content = this.parentElement.nextElementSibling;
            const iconBtn = this.querySelector('.accordion-trigger-btn .icon');

            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);

            if (!isExpanded) {
                content.style.height = content.scrollHeight + 'px';
                content.parentElement.classList.add(settings.openClass);
                iconBtn.classList.add('active')
            } else {
                content.style.height = 0;
                content.parentElement.classList.remove(settings.openClass);
                iconBtn.classList.remove('active')
            }
        });
    });
}

export default createAccordion;